import React from "react";
import styled from "styled-components";
import YoutubeVideo from "./YoutubeVideo";

const InbioVideoContainer = styled("div")`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 24px;

    & div:first-child:not(.tiktok-container) {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
    }

    & iframe {
      top: 0;
      left: 0;
      position: absolute;
      height: 100%;
      width: calc(100% - 4px);
      border: 2px solid #ffffff;
      border-radius: ${(props) => (props.type === "youtube" ? 8 : 26)}px;
    }
  `;

  const InbioTiktokContainer = styled("div")`
    position: relative;
    max-width: 320px;
    cursor: pointer;
  `;

  const InbioTiktokThumb = styled("img")`
    display: block;
    width: 100%;
    border: 2px solid #ffffff;
    border-radius: 26px;
  `;

  const InbioTiktokPlaySVG = styled("div")`
    position: absolute;
    top: calc(50% - 35px);
    left: calc(50% - 35px);
  `;

export default function InbioVideoContent({ content, getIpAndPublishToSns }) {
  return (
    content.type === "InbioVideo" &&
    content.video_data && (
      <InbioVideoContainer type={content.video_data["type"]}>
        {content.video_data["type"] === "youtube" && (
          <YoutubeVideo
            videoId={content.video_data["video_id"]}
            onReady={() => void 0}
            onPlay={() => {
              getIpAndPublishToSns({
                payload: {
                  actor_type: "InbioCustomer",
                  category: "Youtube Content",
                  action: "played",
                  label: content.description,
                  value: content.id,
                  page: window.location.href
                },
                topic: "product_usage_stats",
              });
            }}
          />
        )}
        {content.video_data["type"] === "tiktok" && (
          <InbioTiktokContainer
            className="tiktok-container"
            onClick={() => {
              getIpAndPublishToSns({
                payload: {
                  actor_type: "InbioCustomer",
                  category: "TikTok Content",
                  action: "clicked",
                  label: content.description,
                  value: content.id,
                  page: window.location.href
                },
                topic: "product_usage_stats",
              });
              window.open(content.description, "_blank")
            }}
          >
            <InbioTiktokThumb src={content.image} />
            <InbioTiktokPlaySVG>
              <svg
                className="play-icon"
                width="70"
                height="70"
                viewBox="0 0 48 48"
                fill="#fff"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 8.77702C12 6.43812 14.5577 4.99881 16.5569 6.21266L41.6301 21.4356C43.5542 22.6038 43.5542 25.3962 41.6301 26.5644L16.5569 41.7873C14.5577 43.0012 12 41.5619 12 39.223V8.77702Z"
                ></path>
              </svg>
            </InbioTiktokPlaySVG>
          </InbioTiktokContainer>
        )}
      </InbioVideoContainer>
    )
  );
}
